import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex flex-col',
    headerText:
      'text-s mb-5 flex flex-col leading-[1.5] font-semibold whitespace-pre-wrap max-lg:mb-3',
    resendText: 'mt-8 mb-13 justify-center text-xs',
    inputText: 'not-[&:empty]:border-icon-brand border-b-2 border-black',
    helperText:
      'text-inactive min-h-6 pt-1 text-center text-sm font-light opacity-0',
    loadingContainer:
      'bg-bg-items-white absolute top-0 left-0 flex size-full items-center justify-center',
    loading: 'loading bg-bg-items-white h-5 w-16 transform transition-opacity',
    inputGroup: 'gap-2 max-lg:mt-3.5',
    container: 'justify-center'
  },
  variants: {
    status: {
      completed: {
        helperText: 'text-text-success opacity-100',
        inputText: 'border-text-success'
      },
      error: {
        helperText: 'text-text-error opacity-100',
        inputText: 'border-text-error'
      },
      loading: {},
      default: {}
    }
  },
  defaultVariants: {}
});
